import { Box, Text } from "@chakra-ui/react";
import useMensagemFaltamLer from "features/mensagens/hooks/useMensagemFaltamLer";
import useMensagemLeituras from "features/mensagens/hooks/useMensagemLeituras";
import useReenviarNotificacoesMensagens from "features/mensagens/hooks/useReenviarNotificacoes";
import useFiltro from "infra/helpers/useFiltro";
import ModalTabsParticipantes from "components/ModalTabsParticipantes";
import NumeroLeituras from "ui/pages/Admin/Administracao/Mensagens/NumeroLeituras";

interface ModalLeiturasProps {
  mensagemId: string;
  isOpen: boolean;
  onClose: () => any;
  numDestinos?: number;
  numDestinosLidos?: number;
}

function ModalLeituras({
  mensagemId,
  isOpen,
  onClose,
  numDestinos,
  numDestinosLidos,
}: ModalLeiturasProps) {
  const {
    mutate: reenviarNotificacoes,
    isLoading: isLoadingReenviarNotificacoes,
  } = useReenviarNotificacoesMensagens();
  const { filtro: filtroFaltamLer, onChangeFiltro: onChangeFiltroFaltamLer } =
    useFiltro();
  const {
    data: unidadesFaltamLer,
    isLoading: isLoadingFaltamLer,
    isFetching: isFetchingFaltamLer,
  } = useMensagemFaltamLer({
    mensagemId,
    enabled: isOpen,
    page: filtroFaltamLer.page || 1,
  });

  const { filtro: filtroLeituras, onChangeFiltro: onChangeFiltroLeituras } =
    useFiltro();
  const {
    data: unidadesLeituras,
    isLoading: isLoadingUnidadesLeituras,
    isFetching: isFetchingUnidadesLeituras,
  } = useMensagemLeituras({
    mensagemId,
    enabled: isOpen,
    page: filtroLeituras.page || 1,
  });

  const _isLoadingUnidadesLeituras =
    isLoadingUnidadesLeituras || isFetchingUnidadesLeituras;
  const _isLoadingFaltamLer = isLoadingFaltamLer || isFetchingFaltamLer;

  return (
    <ModalTabsParticipantes
      isOpen={isOpen}
      onClose={onClose}
      firstTabOnPaginate={(p) => onChangeFiltroLeituras("page", p)}
      firstTabTitle="Visualizaram"
      firstTabFiltro={filtroLeituras}
      firstTabData={unidadesLeituras}
      firstTabEmptyMessage="Nenhuma unidade visualizou"
      firstTabIsLoading={_isLoadingUnidadesLeituras}
      firstTabRightElement={
        <NumeroLeituras
          numDestinos={numDestinos}
          numDestinosLidos={numDestinosLidos}
        />
      }
      secondTabFiltro={filtroFaltamLer}
      secondTabOnPaginate={(p) => onChangeFiltroFaltamLer("page", p)}
      secondTabTitle="Não visualizaram"
      secondTabData={unidadesFaltamLer}
      secondTabEmptyMessage="Não falta nenhuma unidade ler"
      secondTabIsLoading={_isLoadingFaltamLer}
      secondTabLeftElement={
        numDestinos !== undefined && numDestinosLidos !== undefined ? (
          <Box mb={2} mt={4} ml={4}>
            <Text fontSize={16} fontWeight="medium">
              Total de unidades que não leram: {numDestinos - numDestinosLidos}{" "}
            </Text>
          </Box>
        ) : null
      }
      reenviarNotificacoes={() => reenviarNotificacoes(mensagemId)}
      isLoadingReenviarNotificacoes={isLoadingReenviarNotificacoes}
    />
  );
}

export default ModalLeituras;
